import { render, staticRenderFns } from "./Func14Detalhe.vue?vue&type=template&id=9648c174&scoped=true"
import script from "./Func14Detalhe.vue?vue&type=script&lang=js"
export * from "./Func14Detalhe.vue?vue&type=script&lang=js"
import style0 from "./Func14Detalhe.vue?vue&type=style&index=0&id=9648c174&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9648c174",
  null
  
)

export default component.exports